"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importStar(require("react"));
const Dialog_1 = __importDefault(require("../Dialog"));
const DO_NOTHING = () => Promise.resolve();
function CreateDialog(props) {
    const { valid = true, onClose, onCreate = DO_NOTHING, afterCreate, children } = props;
    const [busy, setBusy] = (0, react_1.useState)(false);
    const { goBack } = (0, useNav_1.default)();
    const handleClose = (0, react_1.useCallback)(() => (onClose ? onClose() : goBack()), [goBack, onClose]);
    const handleConfirmClick = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        setBusy(true);
        yield onCreate()
            .then(r => (afterCreate ? afterCreate(r) : handleClose()))
            .finally(() => setBusy(false));
    }), [afterCreate, handleClose, onCreate]);
    return (react_1.default.createElement(Dialog_1.default, Object.assign({}, props, { closable: false, buttonsLeft: react_1.default.createElement(Button_1.default, { onClick: handleClose, color: lib_palette_1.default.Grey, disabled: busy, tabIndex: 1, label: lib_i18n_1.default.t('cancel') }), buttonsRight: react_1.default.createElement(Button_1.default, { onClick: handleConfirmClick, disabled: busy || !valid, tabIndex: 0, label: lib_i18n_1.default.t('create') }) }),
        react_1.default.createElement(Spinner_1.default, { busy: busy }, children)));
}
exports.CreateDialog = CreateDialog;
exports.default = CreateDialog;
